import { t } from "@/i18n-js/instance";

import { FormSection } from "./FormSection";
import { SwitchField } from "./SwitchField";

export const Permissions = () => (
  <FormSection title={t("space_groups.form.create.permissions")}>
    <div className="flex flex-col gap-4">
      <SwitchField
        name="hide_members_count"
        label={t("space_groups.form.create.hide_members_count")}
        labelTooltip={t("space_groups.form.create.hide_members_count_tooltip")}
      />
      <SwitchField
        name="is_hidden_from_non_members"
        label={t("space_groups.form.create.is_hidden_from_non_members")}
        labelTooltip={t(
          "space_groups.form.create.is_hidden_from_non_members_tooltip",
        )}
      />
      <SwitchField
        name="hide_non_member_spaces_from_sidebar"
        label={t(
          "space_groups.form.create.hide_non_member_spaces_from_sidebar",
        )}
        labelTooltip={t(
          "space_groups.form.create.hide_non_member_spaces_from_sidebar_tooltip",
        )}
      />
      <SwitchField
        name="allow_members_to_create_spaces"
        label={t("space_groups.form.create.allow_members_to_create_spaces")}
        labelTooltip={t(
          "space_groups.form.create.allow_members_to_create_spaces_tooltip",
        )}
      />
    </div>
  </FormSection>
);
